import { render, staticRenderFns } from "./BandejaClinicaHallazgo.vue?vue&type=template&id=b8f1d6ac"
import script from "./BandejaClinicaHallazgo.vue?vue&type=script&lang=js"
export * from "./BandejaClinicaHallazgo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports